export default __webpack_public_path__ + "static/media/frame-login-bottom.54c8bdf7.svg";